const HashtagAnalysisReport = {

	visual: {
		icon: "va-icon fa fa-pie-chart",
		title: "Hashtag analysis report",
		desc: "Analysis of accounts using a specified hashtag."
	},

	binding: [
	{"hashtag_useage_text": "string","label":"Hashtag Text"},
	{"hashtag_useage_limit": "number", "label":"Hashtag Limit"},
	{"status_created_at_from": "date","label":"Status ('retweets'|'posted') created from"},
	{"status_created_at_to": "date","label":"Status ('retweets'|'posted') created to"},
	],

	query:`
	MATCH 
		(h:Hashtag {text: ':hashtag_useage_text'})-[:HASHTAG_OF]->(s:Status)-[:POSTED_BY]->(a:Account) 
	WHERE 
		date(s.created_at) >= date(':status_created_at_from') AND date(s.created_at) <= date(':status_created_at_to')
	WITH 
		h,collect(distinct a) as accs 
		UNWIND 
			accs as acc  
		MATCH 
			(h2:Hashtag {text: ':hashtag_useage_text'})-[:HASHTAG_OF]->(s2:Status)-[:POSTED_BY]->(a2:Account) 
		WHERE 
			date(s2.created_at) >= date(':status_created_at_from') AND date(s2.created_at) <= date(':status_created_at_to')
		AND 
			a2.id = acc.id 
		WITH 
			h, acc, COUNT(s2) as s_count 
		CALL 
			apoc.create.vRelationship(h,'USED_HASHTAG',{count: s_count}, acc) 
		YIELD rel 
	RETURN 
		acc, rel, h
	ORDER BY 
		(CASE s_count WHEN null THEN {} ELSE s_count END) DESC LIMIT :hashtag_useage_limit
	`,

	config:{
		console_debug:true,
		labels: {
			"Account": {
				"caption": "screen_name"
			},
			"Hashtag": {
				"caption": "hashtag"
			}
		},
		relationships: {
			"USED_HASHTAG": {
				"thickness": "count",
				"caption": false
			}
		},
	}
	
}

export default HashtagAnalysisReport;
